import {
	preventDoubleClick
} from '../global/_doubleClick';

export const getHtmlContent = (html, returnHTML) => {
    var myCallback = () => {
        preventDoubleClick();
    };
    $.ajax({
        url: html,
        success: function(html) {
            returnHTML(html, myCallback);
            return false;
        }
    });
};
